module.exports = __webpack_public_path__ + "img/prp_platinum.d7e9cc16.png";